<template>
	<div v-if="!hidden" class="col-lg-12">
		<div class="dynvibeBox">
			<div class="col-lg-12">
				<table class="table dynvibeTable">
					<thead>
						<p @click="reset">Reset tab</p>
						<tr class="col-xs-12">
							<th class="col-xs-1">&nbsp;</th>
							<th class="col-xs-2" @click="orderBy('name')">{{ level }}</th>
							<th class="col-xs-1" @click="orderBy('flame')">
								<img class="flame-img" src="/img/flame.png" />
							</th>
							<th class="col-xs-1" @click="orderBy('lightning')">
								<img class="lightning-img" src="/img/lightning.png" />
							</th>
							<th class="col-xs-1" @click="orderBy('volume')">Volume</th>
							<th class="col-xs-2" @click="orderBy('augmentation')">% augmentation</th>
							<th class="col-xs-2" @click="orderBy('diffusion')">% diffusion</th>
							<th class="col-xs-2" @click="orderBy('related')">Related topics</th>
						</tr>
					</thead>
					<tbody v-if="allData.length > 0">
						<tr v-for="(line, index) in allData" class="col-xs-12" :key="index">
							<td class="col-xs-1">
								<button id="create" class="btn openButton" v-on:click="createMastertag(line[0])">open</button>
								<span id="reject" class="fas fa-trash red" v-on:click="rejectWord(index, line[0])"></span>
							</td>
							<td class="col-xs-2">{{ line[0] }}</td>
							<td class="col-xs-1"><img v-if="line[1]" class="flame-img" src="/img/flame.png" /></td>
							<td class="col-xs-1">
								<img v-if="line[2]" class="lightning-img" src="/img/lightning.png" />
							</td>
							<td class="col-xs-1">{{ line[3] }}</td>
							<td class="col-xs-2">{{ line[4] }} %</td>
							<td class="col-xs-2">{{ line[5] }} %</td>
							<td class="col-xs-2">{{ line[6] }}</td>
						</tr>
					</tbody>
					<tbody v-if="!loading && allData.length === 0">
						<tr class="col-xs-12 noData">
							<td class="col-xs-12">No Data to display</td>
						</tr>
					</tbody>
					<div v-if="loading" class="col-lg-12 dynvibeLoading"></div>
					<tfoot>
						<p v-if="!loading && canShowMore" @click="loadMore">Show More</p>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "dynvibedynamictable",
	props: {
		level: {
			type: String,
			default: "",
		},
		semanticfilters: Object,
		trendfilters: Object,
	},
	data() {
		return {
			hidden: true,
			loading: false,
			//sliceData: 10,
			rawData: [],
			allData: [],
			//columnSortId: 0,
			//columnSortOrder: "desc",
			filters: {
				lang: "",
			},
			sort: {
				field: "augmentation",
				order: "desc",
			},
			sortFrom: 0,
			sortSize: 10,
			append: false,
			canShowMore: true,
		};
	},
	computed: {},
	methods: {
		loadComponent() {},
		treatResponse(response) {
			if (response.data.results.length === 0) {
				this.canShowMore = false;
				this.loading = false;
				return;
			}
			this.allData = [];
			if (!this.append) {
				this.rawData = [];
			}

			this.rawData = [...this.rawData, ...response.data.results]; // merge
			this.sortFrom = parseInt(response.data.sortFrom);
			for (let i = 0; i < this.rawData.length; i++) {
				this.allData.push([this.rawData[i]["key"], false, false, this.rawData[i]["doc_count"], 0, 0, 0]);
			}

			this.loading = false;
			this.dataCompute();
		},
		checkFilters() {
			for (let i = 0; i < this.languageslist.length; i++) {
				if (this.languageslist[i]["country"] == this.trendfilters.country.name) {
					this.filters.lang = this.languageslist[i]["language"];
				}
			}
			this.hidden = false;
			this.loading = true;

			// DEVELOPMENT
			/*			this.getData("getStats", {
				//type: this.type,
				level: this.level,
				route: "incoming",
				filters: {
					panel: this.trendfilters.panel,
					segment: this.trendfilters.segment,
					date: this.trendfilters.date,
					country: this.trendfilters.country,
					lang: this.filters.lang,
					category: this.trendfilters.category,
					subcategory: this.trendfilters.subcategory,
					mastertag: this.trendfilters.mastertag,
					sort: this.sort,
					sortFrom: this.sortFrom,
					sortSize: this.sortSize,
				},
			});*/

			// PRODUCTION
			if (
				(this.trendfilters.panel || this.trendfilters.segment) &&
				this.trendfilters.date.gte &&
				Object.keys(this.trendfilters.country).length > 0
			) {
				this.getData("getStats", {
					route: "incoming",
					level: this.level,
					filters: {
						panel: this.trendfilters.panel,
						segment: this.trendfilters.segment,
						date: this.trendfilters.date,
						country: this.trendfilters.country,
						lang: this.filters.lang,
						category: this.trendfilters.category,
						subcategory: this.trendfilters.subcategory,
						mastertag: this.trendfilters.mastertag,
						sort: this.sort,
						sortFrom: this.sortFrom,
						sortSize: this.sortSize,
					},
				});
			} else {
				this.hidden = true;
			}
		},
		orderBy(column) {
			this.append = false;
			this.allData = [];
			this.rawData = [];
			this.sortFrom = 0;
			this.sortSize = 10;
			this.canShowMore = true;

			if (this.sort.field === column) {
				this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
			} else {
				this.sort.field = column;
				this.sort.order = "desc";
			}
			this.checkFilters();
		},
		/*columnOrderBy(columnId) {
			// Asc
			if ((this.columnSortId == columnId && this.columnSortOrder == "desc") || (columnId == 0 && this.columnSortId != columnId)) {
				this.allData = this.allData.sort(function (a, b) {
					return a[columnId] > b[columnId] ? 1 : -1;
				});
				this.columnSortOrder = "asc";
			}
			// Desc
			else {
				this.allData = this.allData.sort(function (a, b) {
					return a[columnId] > b[columnId] ? -1 : 1;
				});
				this.columnSortOrder = "desc";
			}
			this.columnSortId = columnId;
		},*/
		dataCompute() {
			for (let i = 0; i < this.rawData.length; i++) {
				// Flame (last month, last month -1)
				let evolution = this.rawData[i]["evolution"]["buckets"];
				let flame = 0;

				let evolution_previous = evolution[0]["doc_count"];
				let evolution_last = evolution[1]["doc_count"];
				if (evolution_previous !== 0) {
					flame = Math.round(((evolution_last - evolution_previous) / evolution_previous) * 100);
				}

				this.allData[i][1] = flame >= 30 ? true : false;

				let buckets = this.rawData[i]["date_range"]["buckets"];

				let bucketDocCount0 = buckets[0]["doc_count"];
				let bucketDocCount1 = buckets[1]["doc_count"];
				let bucketCountValue0 = buckets[0]["count"]["value"];
				let bucketCountValue1 = buckets[1]["count"]["value"];

				// prevent division by 0
				bucketDocCount0 = bucketDocCount0 === 0 ? 1 : bucketDocCount0;
				bucketCountValue0 = bucketCountValue0 === 0 ? 1 : bucketCountValue0;
				bucketCountValue1 = bucketCountValue1 === 0 ? 1 : bucketCountValue1;

				// Lightning
				let ln = bucketDocCount1 / bucketCountValue1;
				let ln_1 = bucketDocCount0 / bucketCountValue0;

				this.allData[i][2] = Math.round(ln - ln_1) >= 30 ? true : false;
				//this.allData[i][2] = Math.round(ln - ln_1)

				// % augmentation, % diffusion
				let aug = Math.round(((bucketDocCount1 - bucketDocCount0) / bucketDocCount0) * 100);
				let diff = Math.round(((bucketCountValue1 - bucketCountValue0) / bucketCountValue0) * 100);

				this.allData[i][4] = aug;
				this.allData[i][5] = diff;

				// Related Topics
				this.allData[i][6] = buckets[1]["relatedtopics"]["value"];
			}

			//this.columnOrderBy(4);
		},
		createMastertag(keyword) {
			this.$emit("createmastertag", { mainkeyword: keyword, level: this.level, lang: this.filters.lang });
		},
		rejectWord(index, keyword) {
			this.$axios
				.get(this.$backendUrl + "rejectTableWord", {
					params: {
						filters: {
							panel: this.trendfilters.panel,
							segment: this.trendfilters.segment,
							word: keyword,
						},
					},
					paramsSerializer: function (params) {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then(() => {
					this.allData.splice(index, 1);
				});
		},
		loadMore() {
			this.sortFrom += this.sortSize;
			this.append = true;
			this.checkFilters();
		},
		reset() {
			this.rawData = [];
			this.allData = [];
			this.sort = {
				field: "augmentation",
				order: "desc",
			};
			this.sortFrom = 0;
			this.sortSize = 10;
			this.append = false;
			this.canShowMore = true;
			this.checkFilters();
		},
	},
	watch: {
		semanticfilters() {
			this.reset();
			//this.checkFilters();
		},
		trendfilters() {
			this.reset();
			//this.checkFilters();
		},
	},
};
</script>
<style scoped>
#reject,
#create {
	font-size: 1em;
	cursor: pointer;
}

#reject {
	font-size: 1.2em;
	display: inline-block;
	margin-left: 10px;
	color: #ef402d;
}

/*th, td {
    border:1px solid #000;

}*/
thead {
	width: 100%;
}

table.dynvibeTable tr th {
	cursor: pointer;
}

table th img {
	filter: grayscale(100%);
}

table tr {
	padding: 0;
}

table tr img {
	height: 24px;
	width: 24px;
}

.dynvibeTable tbody {
	min-height: 380px;
	height: 100%;
	overflow: hidden;
}

thead > p,
tfoot p {
	text-align: right;
	text-decoration: underline;
	cursor: pointer;
	text-transform: capitalize;
}

.noData {
	font-family: "Montserrat";
	text-align: center;
	text-transform: none;
	font-size: 22px;
	font-weight: 400;
	font-style: italic;
	color: #9e9e9e;
	margin-top: 18 px;
}

.openButton {
	border: 1px solid #33d1cd;
	background-color: #fff;
	color: #33d1cd;
	padding: 2px 5px;
}

.openButton:hover,
.openButton:focus,
.openButton:focus-visible {
	outline: none !important;
	background-color: #33d1cd;
	color: #fff;
}

.red {
	color: #ef402d;
}
</style>
